var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "autocomplete-form",
      attrs: {
        method: "get",
        "accept-charset": "utf-8",
        name: "header_search",
        action: _vm.autocompleteUrl,
      },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.search.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "autocomplete-form__container" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.keyword,
              expression: "keyword",
            },
          ],
          staticClass: "autocomplete-form__input",
          attrs: {
            type: "text",
            id: "autocomplete-" + parseInt(Math.random() * 1000),
            name: "search",
            autocomplete: "off",
            placeholder: _vm.placeholder,
          },
          domProps: { value: _vm.keyword },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.keyword = $event.target.value
              },
              _vm.search,
            ],
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "autocomplete-form__submit",
            attrs: {
              href: "/vyhladavanie?search=" + _vm.keyword,
              type: "submit",
            },
          },
          [
            _c("i", {
              staticClass: "ico ico-search",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        ),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      { staticClass: "autocomplete-form__close", attrs: { type: "button" } },
      [
        _c("i", {
          staticClass: "ico ico-close",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }